package demos.counter

import androidx.compose.animation.*
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign

const val COUNTER_BASIC_ANIMATION = "b2c69becf003c3c8683f2d594817f1e26594df27"

@OptIn(ExperimentalAnimationApi::class)
@Composable
fun CounterBasicAnimation() {

    var count by remember { mutableStateOf(0) }

    Column(
        modifier = Modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {

        CounterButton("+") { count++ }


        AnimatedContent(
            targetState = count,
            transitionSpec = {
                if (targetState > initialState) {
                    slideInVertically { -it } with slideOutVertically { it }
                } else {
                    slideInVertically { it } with slideOutVertically { -it }
                }
            }
        ) { count ->
            Text(
                "$count",
                style = MaterialTheme.typography.h3,
                textAlign = TextAlign.Center,
            )
        }

        CounterButton("-") { count-- }
    }

}